import { DELETE_ANSWER, GET_ANSWERS, GET_ANSWERS_PAGINATED, GET_FORMS_SUMMARY, GET_STUDIES_QUESTIONS, GET_STUDY, STUDIES, } from "resources/ApiUrls"
import StudiesAxiosInstance from "utils/StudiesAxiosInstance"

const getAll = () => StudiesAxiosInstance.get(STUDIES)

const get = (studyId) => StudiesAxiosInstance.get(GET_STUDY(studyId))

const getFormsSummary = (studyId) => StudiesAxiosInstance.get(GET_FORMS_SUMMARY(studyId))

const getAllFormAnswers = (formId) => StudiesAxiosInstance.get(GET_ANSWERS(formId))

const getFormAnswers = (formId, page, size) => StudiesAxiosInstance.get(GET_ANSWERS_PAGINATED(formId, page, size))

const getQuestions = (studyId, formId) => StudiesAxiosInstance.get(GET_STUDIES_QUESTIONS(studyId, formId))

const deleteAnswer = (answerId) => StudiesAxiosInstance.post(DELETE_ANSWER, answerId)

const studyAPICalls = { getAll, get, getFormsSummary, getAllFormAnswers, getFormAnswers, getQuestions, deleteAnswer }

export default studyAPICalls